import { useCallback } from 'react';

import DomainTagsForm from './DomainTagsForm';
import DomainTagsTable from './DomainTagsTable';
import SettingsDialogPage from '../../../../../../components/SettingsDialogPage';
import { useSettingsDialog } from '../../../../../../hooks/useSettingsDialog';
import { DomainType } from '../../../../../../types/domain';
import { SettingTagByDomainType } from '../../../../types/settingTag';

type DomainTagsTableProps = {
	domain: DomainType;
};

const DomainTags = ({ domain }: DomainTagsTableProps) => {
	const { push } = useSettingsDialog();

	const handleTagSelection = useCallback(
		(tag?: SettingTagByDomainType) => {
			push(<DomainTagsForm domain={domain} tag={tag} />);
		},
		[domain, push],
	);

	return (
		<SettingsDialogPage title={domain.name}>
			<DomainTagsTable domain={domain} onTagSelection={handleTagSelection} />
		</SettingsDialogPage>
	);
};

export default DomainTags;
